<template>
    <div>
        <div v-if="scrollPosition >= scrollThreshold" class="header__placeholder">
        </div>
        <header  class="header" :class="[disabled ? 'disabled' : '', scrollPosition >= scrollThreshold ? 'sticky' : '']">
            <div class="header__top" ref="top" :class="{'header__top--not_auth' : authenticated === false}">
                <div class="container">
                    <div class="row">
                        <div class="col-7 col-sm-5">
                            <router-link :to="{ name: 'home' }" class="header__logo">
                                <img src="/static/img/logo_minimax.png" alt="Minimax Client Dashboard" title="Minimax Client Dashboard" height="32px">
                            </router-link>
                        </div>
                        <div class="hidden-xs col-sm-5" v-if="authenticated">
                            <div class="header__intro">
                                <p>{{$t('menu.welcome_to_account')}}</p>
                                <h2>{{username}}</h2>
                            </div>
                        </div>
                        <div class="hidden-xs col-sm-2" v-if="authenticated">
                            <button @click="signOut"
                                    class="header__logout">
                                {{$t('menu.signout')}}
                            </button>
                        </div>
                        <div class="visible-xs visible-sm col-5 col-sm-7" v-else>
                            <div class="locale_block">
                                <locale-button class="locale_block__button--first" language="nl"/>
                                <locale-button class="locale_block__button" language="fr"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="header__content" v-if="showNavigation">
                <template>
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <a href="#" class="nav__toggle_mobile" @click.prevent="toggleMobileMenu()">
                                <span class="nav__toggle_mobile__icon">
                                <transition name="fade">
                                    <i class="mdi mdi-menu nav-icon-dark" v-show="!showMobileMenu"></i>
                                </transition>
                                <transition name="fade">
                                    <i v-show="showMobileMenu" class="mdi mdi-close nav-icon-dark"></i>
                                </transition>
                            </span>
                                    <span class="nav__toggle_mobile__text">
                                    Menu
                                </span>
                                </a>
                            </div>

                            <!-- Workaround to allocate space for the blue header button -->
                            <div class="col-6" v-if="!headerButtonVisible">
                                <router-link :to="{ name: 'referrals' }"  class="header__button hidden">
                                    {{$t('menu.referrals')}}
                                    <span class="header__button__sub_text">{{$t('menu.referrals_sub')}}</span>
                                </router-link>
                            </div>
                            <transition name="slide-right">
                                <div class="col-6" v-show="headerButtonVisible">
                                    <router-link :to="{ name: 'referrals' }" @click.native="toggleMobileMenu('referrals')" class="header__button">
                                        {{$t('menu.referrals')}}
                                        <span class="header__button__sub_text">{{$t('menu.referrals_sub')}}</span>
                                    </router-link>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <nav class="nav" :class="{ 'is-active': showMobileMenu }">
                        <div class="container nav__setup">
                            <h4>{{ $t('menu.start') }}</h4>
                            <setup-steps></setup-steps>
                        </div>
                        <div class="disabled__message">
                            <p>{{$t('menu.available_after_installation')}}</p>
                        </div>
                        <div class="container has-margin-bottom">
                            <ul>
                                <li class="nav__item" @click="toggleMobileMenu('saltblocks')">
                                    <router-link :to="{ name: 'saltblocks' }"  class="nav__link">{{$t('menu.saltblocks')}}
                                        <p class="nav__item__sub">{{$t('menu.saltblocks_sub')}}</p>
                                    </router-link>
                                </li>
                                <li class="nav__item" @click="toggleMobileMenu('orders')" >
                                    <router-link :to="{ name: 'orders' }" class="nav__link">{{$t('menu.orders')}}
                                        <p class="nav__item__sub">{{$t('menu.orders_sub')}}</p>
                                    </router-link>
                                </li>
                                <!-- <li class="nav__item" @click="toggleMobileMenu('support')">
                                    <router-link :to="{ name: 'support' }"  class="nav__link">{{$t('menu.support')}}
                                        <p class="nav__item__sub">{{$t('menu.support_sub')}}</p>
                                    </router-link>
                                </li> -->
                                <li class="nav__item" @click="toggleMobileMenu('info')" >
                                    <router-link :to="{ name: 'account' }" class="nav__link">{{$t('menu.info')}}
                                        <p class="nav__item__sub">{{$t('menu.info_sub')}}</p>
                                    </router-link>
                                </li>
                                <!-- <li class="nav__item" @click="toggleMobileMenu('experiences')" >
                                    <router-link :to="{ name: 'experiences' }" class="nav__link">{{$t('menu.experiences')}}
                                        <p class="nav__item__sub">{{$t('menu.experiences_sub')}}</p>
                                    </router-link>
                                </li> -->
                                <li class="nav__item locale_block">
                                    <locale-button class="locale_block__button--first" language="nl"/>
                                    <locale-button class="locale_block__button" language="fr"/>
                                    <button v-if="authenticated" @click="signOut" class="locale_block__logout">
                                        {{$t('menu.signout')}}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </template>
            </div>
        </header>
    </div>

</template>

<script>
    import Vue from 'vue';
    import {Component, Watch} from 'vue-property-decorator';
    import {LOGOUT, IS_AUTHENTICATED} from '../../store/modules/auth';
    import LocaleButton from './LocaleButton';
    import SetupSteps from './SetupSteps';
    import {GET_USERNAME} from '../../store/modules/account_details';
    import {GET_INSTALLATION_PLACED} from '../../store/modules/proposal_progress';
    import { SCREEN_MD } from '../../constants/breakpoints';

    @Component({
        components: {LocaleButton, SetupSteps}
    })
    export default class TheHeader extends Vue{
        name = 'the-header';
        showMobileMenu = false;
        currentPage;
        scrollPosition = 0;
        scrollThreshold = 64;
        scrollPositionBeforeMenu = 0;
        samePage = false;
        headerButtonVisible = false;
        thresholdVisibileHeaderButton = 620;

        get disabled(){
            return !this.$store.getters[GET_INSTALLATION_PLACED];
        }

        @Watch('showMobileMenu')
        hideElementsBehindMenu(){
            // 'disable-scrolling' class is workaround to prevent bug on mobile phone (=> quick scrolling made the page behind the menu visible)
            if (this.showMobileMenu) {
                window.scrollTo(0,this.scrollPositionBeforeMenu);
                document.body.classList.add('disable-scrolling');

                // Show the blue header button on menu
                this.headerButtonVisible = true;
            } else {
                document.body.classList.remove('disable-scrolling');
                this.$el.querySelector('nav').scrollTop = 0; // Reset scroll position menu
                if (this.samePage) {
                    // If the menu is closed but the user is still on the same page, reset the scrolling position to where it was before the menu was launched.
                    window.scrollTo(0,this.scrollPositionBeforeMenu);
                } else {
                    window.scrollTo(0,0);

                    // Hide the blue header button
                    if (window.innerHeight < this.thresholdVisibileHeaderButton) {
                        this.headerButtonVisible = false;
                    }
                }
            }
        }

        mounted(){
            window.addEventListener('scroll', this.onScroll);
            if (this.$refs.top.clientHeight != 0){
                this.scrollThreshold = this.$refs.top.clientHeight;
            }
        }

        beforeDestroy(){
            window.removeEventListener('scroll', this.onScroll);
        }

        created() {
            this.currentPage = this.$route.name;

            if (window.innerHeight > this.thresholdVisibileHeaderButton) {
                // Always show the blue header button on iPads
                this.headerButtonVisible = true;
            }
        }

        toggleMobileMenu(page) {
            // Set samePage to false if a page is given as a parameter, which indicates that the user has pressed a page in the menu
            this.samePage = !page;
            this.scrollPositionBeforeMenu = window.scrollY;

            if (page == 'referrals') {
                this.headerButtonVisible = false;
                this.showMobileMenu = false;
            } else if (this.$mq.below(SCREEN_MD)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }
        @Watch('$mq.resize')
        hideMobileMenu() {
            if (this.$mq.above(SCREEN_MD)) {
                this.showMobileMenu = false;
            }
        }

        signOut() {
            this.hideMobileMenu();
            document.body.classList.remove('disable-scrolling');
            this.$store.dispatch(LOGOUT).then(() => {
                this.$router.replace({
                    name: 'sign-in'
                });
            });
        }

        get showNavigation() {
            return !this.$route.path.startsWith('/auth');
        }

        get authenticated() {
            return this.$store.getters[IS_AUTHENTICATED];
        }

        get username() {
            return this.$store.getters[GET_USERNAME];
        }

        onScroll(){
            this.scrollPosition = window.scrollY;

            // Show the blue header button if user scrolls below threshold
            if (this.scrollPosition >= this.scrollThreshold && !this.$route.path.startsWith('/referrals')){
                this.headerButtonVisible = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/TheHeader.vue